import React from "react";
import ReactDOM from "react-dom/client";
import "./i18n/i18n";
import App from "./app/App";
import { Provider } from "react-redux";
import store from "./reduxData/store";
import { messaging } from "./config/firebase";
console.error = console.warn = () => { };

if ("serviceWorker" in navigator) {
  navigator.serviceWorker
    .register("/firebase-messaging-sw.js")
    .then((registration) => {
      //console.log("Service Worker registered with scope:", registration.scope);
      messaging.useServiceWorker(registration);
    })
    .catch((err) => {
      console.error("Service Worker registration failed:", err);
    });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
